import React from 'react';
import loadable from '@loadable/component';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

// Seva Sethu Terms of Service content
const fallbackTerms = `
*Last updated: December 2024*

## Welcome to Seva Sethu

These Terms of Service ("Terms") govern your use of the Seva Sethu Marketplace ("Platform"), operated by Seva Sethu ("we," "us," or "our"). By accessing or using our Platform, you agree to be bound by these Terms.

## Account Registration

- You must be at least 18 years old to create an account
- You are responsible for maintaining the security of your account
- You must provide accurate and complete information during registration
- One person may not maintain multiple accounts

## Marketplace Rules

### For Buyers:
- You agree to pay for items purchased through the Platform
- You must communicate respectfully with sellers
- Disputes should first be addressed directly with the seller

### For Sellers:
- You must accurately describe your products and services
- You are responsible for fulfilling orders in a timely manner
- You must comply with all applicable laws and regulations
- Products must align with our community values (no meat, eggs, onion, garlic, or intoxicants)

## Prohibited Items

The following items are not permitted on Seva Sethu:
- Non-vegetarian food items (meat, poultry, fish, seafood, eggs)
- Foods containing onion, garlic, or mushrooms
- Alcohol, tobacco, or any intoxicants
- Items that infringe on intellectual property rights
- Counterfeit or fraudulent products

## Payment & Fees

- All prices are listed in USD
- Payment processing is handled by our secure payment partners
- Sellers receive payment after order completion (minus applicable fees)

## Limitation of Liability

We are not liable for:
- Disputes between buyers and sellers
- Quality issues with products or services
- Delivery delays or shipping issues
- Any indirect or consequential damages

## Modifications

We reserve the right to modify these Terms at any time. Continued use of the Platform after changes constitutes acceptance of the new Terms.

## Contact Us

For questions about these Terms, please contact us at support@seva-sethu.com.
`;

// Create fallback content (array of sections) in page asset format:
export const fallbackSections = {
  sections: [
    {
      sectionType: 'article',
      sectionId: 'terms',
      appearance: { fieldType: 'customAppearance', backgroundColor: '#ffffff' },
      title: { fieldType: 'heading1', content: 'Terms of Service' },
      blocks: [
        {
          blockType: 'defaultBlock',
          blockId: 'hero-content',
          text: {
            fieldType: 'markdown',
            content: fallbackTerms,
          },
        },
      ],
    },
  ],
  meta: {
    pageTitle: {
      fieldType: 'metaTitle',
      content: 'Terms of Service | Seva Sethu',
    },
    pageDescription: {
      fieldType: 'metaDescription',
      content: 'Terms of Service for Seva Sethu Marketplace - Rules and guidelines for using our community marketplace.',
    },
  },
};

// This is the fallback page, in case there's no Terms of Service asset defined in Console.
const FallbackPage = props => {
  return <PageBuilder pageAssetsData={fallbackSections} {...props} />;
};

export default FallbackPage;
